<template>
  <div class="cover-page">
    <div class="back-content">
      <div class="title"> 欢迎 </div>
    </div>
    <van-popup class="cover" :value="inited" :close-on-click-overlay="false">
      <div class="content">
        <div class="logo">
          <img :src="logoUrl" />
        </div>
        <template v-if="auto == 2">
        <div class="login">
          <van-button type="primary" round @click="doLiveQ" style="width: 80%">进入节目</van-button>
        </div>
        </template>
        <template v-else>
        <div class="tips">{{ state !== '94zRUOsohk' ? '使用系统完整功能需要授权' : '授权后可以参与活动' }}</div>
        <div class="login">
          <van-button type="primary" round @click="doLogin" style="width: 80%">点击授权</van-button>
        </div>  
        </template>
      </div>
    </van-popup>
  </div>
</template>

<script>
export default {
  name: 'Cover',
  data() {
    return {
      state: '',
      inited: false,
      auto: 1,
    }
  },
  async mounted() {
    this.state = this.$route.query.state;
    this.auto = +(this.$route.query.auto || 1);
    await this.init();
  },
  computed: {
    logoUrl() {
      return window.__config__.cover_url;
    },
  },
  methods: {
    async init() {
      // if (!this.auto) {
      //   this.inited = true;
      //   return;
      // }
      if (this.auto == 2) {
        this.doLogin();
      }
      if (this.$store.state.token) {
        try {
          await this.$store.dispatch('syncUser');
        } catch (e) {}
      }
      if (this.$store.state.user) {
        if (this.auto && (this.$store.state.user.member_type == 1 || this.$store.state.user.member_type == 0)) {
          this.$router.replace('/live?state=' + this.state);
          return;
        } else if (this.$store.state.user.member_type == 2) {
          this.$router.replace('/GMChart');
          return;
        } else if (this.$store.state.user.member_type == 3) {
          this.$router.replace('/DisIndex');
          return;
        }
      }
      this.inited = true;
    },
    async doLogin() {
      let state = this.$route.query.state;
      if (!state) {
        this.$router.replace('/error')
        return;
      }
      // if (this.auto == 2) {
      //   this.$router.replace('/live-q?state=' + this.state);
      // } else {
      setTimeout(() => {
        const appid = window.__config__.appid
        const service_url = encodeURI(window.__config__.server_url + 'auth/wechat_auth')
        const url = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appid}&redirect_uri=${service_url}&response_type=code&scope=snsapi_userinfo&state=${state}#wechat_redirect`
        location.href = url
      }, 10);
      // }
    }
  }
}
</script>
<style scoped>
.cover-page {
  position: relative;
  background: #fefefe;
  width: 100vw;
  height: 100vh;
}
.title {
  height: 60px;
  padding: 10px;
  line-height: 40px;
  overflow: hidden;
  word-break: keep-all;
  text-align: center;
  background: #fff;
}
.cover {
  z-index: 999;
  position: absolute;
  top: 50%;
  left: 50%;
  width: 400px;
  max-width: 80vw;
  transform: translate(-50%, -50%);
  background: #f8fbfa;
  border-radius: 10px;
}
.cover .content {
  position: relative;
}
.logo {
  padding: 40px 0 20px 0;
  text-align: center;
  
}
.logo img {
  width: 80%;
}
.tips {
  margin: 20px;
  text-align: center;
  color: #888;
  font-size: 16px;
}
.login {
  position: relative;
  z-index: 999;
  margin: 50px;
  display: flex;
  justify-content: center;
}
.notice {
  position: absolute;
  bottom: 50px;
  left: 0;
  width: 100%;
  font-size: 14px;
  color: #666;
  text-align: center;font-size: 16px;
}
.notice span {
  color: #b06563;
}
</style>
